import Resource from '@/api/resources/Resource'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'

class CommonSubportionServices extends Resource {
    async getSubportionInformation(labId, caseId, sampleId, portionId, subportionId) {
        const response = await this.axios.get(`/common/laboratories/${labId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/subportions/${subportionId}`)
        return response.data
    }

    async findByLabel(laboratoryId, subportionLabel) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/cases/samples/portions/subportions/${subportionLabel}/findByLabel`)
        return response.data
    }

    async getTracking(laboratoryId, caseId, sampleId, portionId, subportionId) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/subportions/${subportionId}/tracking`)
        return response.data
    }

    async getSubportionsByCaseId(laboratoryId, caseId) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/cases/${caseId}/samples/portions/subportions`)
        return response.data
    }

    async search(params) {
        const response = await this.axios.get('/common/subportions/search', { params })
        return response.data
    }

    async getNextSubportionCodes(laboratoryId, params) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/cases/samples/portions/subportions/getNextSubportionCodes`, { params })
        return response.data
    }

    async exportTo(laboratoryId, caseId, sectionLabel, filterModel, sortModel, columns, selectedIds, exportType) {
        const params = {
            page: 0,
            size: PAGINATOR_BIG_PAGE_SIZE,
            sort: sortModel,
            exportType
        }
        return this.axios.put(
            `/common/laboratories/${laboratoryId}/cases/${caseId}/samples/portions/subportions/export`,
            { sectionLabel, filterModel, columns, entityIdentifiersRequest: { entityIdentifiers: selectedIds } },
            { params, responseType: 'arraybuffer' })
    }
}

export default new CommonSubportionServices()
